import { quantityBtn } from "../components/quantityBtn";
import { videoPlayer } from "../components/videoPlayer";
import { dropdownSlide } from "../components/dropdownSlide";
import { seeMoreBtn } from "../components/seeMoreBtn";
import { header } from "../components/header";
import { langDropdown } from "../components/langDropdown";
import { categorySlider } from "../components/categorySlider";
import { articlesSlider } from "../components/articlesSlider";
import { carManufacturersSlider } from "../components/carManufacturersSlider";
import { homepageSlider } from "../components/homepageCarousel";
import { floatingLabels } from "../components/floatingLabels";
import { formSubmitEnable } from "../components/formSubmitEnable";
import { registerBtnEnable } from "../components/registerBtnEnable";
import { scrollButton } from "../components/scrollButton";
import { searchBar } from "../components/searchBar";
import { userDropdown } from "../components/userDropdown";
import { confirmationBlockOpen } from "../components/confirmationBlockOpen";
import { modal } from "../components/modal";
import { resellersModalSlider } from "../components/resellersModalSlider";
import { resellersModalRequest } from "../components/resellersModalRequest";
import { faqCategories } from "../components/faqCategories";
import { homepageParallax } from "../components/homepageParallax";
import { emailValidation } from "../components/emailValidation";
import { carSelector } from "../components/carSelector";
import { campaignBannerSlider } from "../components/campaignBannerSlider";
import { campaignFormScroll } from "../components/campaignFormScroll";
import { campaignStickyButton } from "../components/campaignStickyButton";
import { solutionEqualHeight } from "../components/solutionEqualHeight";
import { glsParcelShopModalRequestModalRequest } from "../components/glsParcelShopModalRequest";

export const componentLoader = {
	page: null,
	checkInitializedPage: function() {
		this.enableDefaultComponents();
		switch (this.page) {
			case "index":
				carManufacturersSlider();
				articlesSlider();
				homepageSlider();
				scrollButton();
				homepageParallax();
				break;
			case "product-page":
				quantityBtn.init(document.querySelectorAll('.product-price-section__quantity-value'));
				videoPlayer.init(document.querySelector('.video-player'));
				carManufacturersSlider();
				dropdownSlide.init();
				seeMoreBtn();
				break;
			case "product-page-no-product":
				videoPlayer.init(document.querySelector('.video-player'));
				carManufacturersSlider();
				dropdownSlide.init();
				seeMoreBtn();
				break;
			case "subcategory-page":
			case "category-page":
			case "category-page-subcategories":
				categorySlider();
				carManufacturersSlider();
				break;
			case "domain-page":
				articlesSlider();
				carManufacturersSlider();
				break;
			case "articles":
				categorySlider();
				break;
			case "article-details":
				videoPlayer.init(document.querySelector('.video-player'));
				break;
			case "faq":
				dropdownSlide.init();
				faqCategories.init();
				break;
			case "checkout":
			case "checkout-step-1":
			case "checkout-step-1-logged-in":
				quantityBtn.init(document.querySelectorAll('.basket-products__quantity-button'));
				emailValidation.init(document.querySelector('.checkout-delivery-form'));
				formSubmitEnable.init(document.querySelector('.checkout-delivery-form'));
				floatingLabels.init(document.querySelector('.basket-wrapper'));
				resellersModalSlider();
				glsParcelShopModalRequestModalRequest.init(document.querySelector('.parcel-shop-selector'));
				break;
			case "checkout-info":
			case "checkout-success-register":
				floatingLabels.init(document.querySelector('.checkout-login-form'));
				registerBtnEnable.init(document.querySelector('.checkout-info'));
				break;
			case "industry":
				videoPlayer.init(document.querySelector('.video-player'));
				break;
			case "dealer-form":
				floatingLabels.init(document.querySelector('.dealer-form'));
				break;
			case "user-page":
				confirmationBlockOpen.init(document.querySelectorAll('.user-page__address'))
				break;
			case "user-page-data-modifications":
				floatingLabels.init(document.querySelector('.checkout-form-fields'));
				break;
			case "contact":
			case "press-contact":
				floatingLabels.init(document.querySelector('.contact-page-wrapper'));
				break;
			case "register":
				floatingLabels.init(document.querySelector('.register'));
				break;
			case "questionnaire-result":
				articlesSlider();
				resellersModalSlider();
				resellersModalRequest.init(document.querySelector('.jsResellersSearch'));
				break;
			case "econettoyage":
				resellersModalSlider();
				resellersModalRequest.init(document.querySelector('.jsResellersSearch'));
				break;
			case "car-selector":
				carSelector.init(document.querySelector('.car-selector'));
				break;
			case "campaign-landing-page":
				floatingLabels.init(document.querySelector('.diagnostic-form__form-wrapper'));
				campaignStickyButton.init();
				campaignBannerSlider(document.querySelector('.jsCampaignSlider'));
				campaignFormScroll();
				solutionEqualHeight(document.querySelector('.solutions__items'));
				break;
			case "templates":
				floatingLabels.init(document.querySelector('.form-template'));
				break;			
			default:
				console.info("only default components");
		}
	},
	enableDefaultComponents: function() {
		header.init(document.querySelector('.header'));
		searchBar(document.querySelector('.search-bar'));
		langDropdown();
		userDropdown();
		svg4everybody();
		modal.init(document.querySelector('.jsModalQuestionnarie'));
	}
};
